<script setup lang="ts">
  import { ref } from 'vue';

  import { SMSStatus } from '@stuut/api-sdk/models';
  import { Button } from '@ui/components/button';
  import { toast } from '@ui/components/sonner';

  import { sdk } from '@/sdk';

  interface Props {
    body: string;
    smsId: string;
  }

  const props = defineProps<Props>();
  const emit = defineEmits<{
    (e: 'sent'): void;
  }>();

  const isSending = ref(false);

  const sendDraft = async () => {
    if (isSending.value) return;

    isSending.value = true;
    try {
      // Update the draft body
      await sdk.smsThreads.updateMessage({
        smsId: props.smsId,
        body: { body: props.body.trim() },
      });

      // Send the updated draft
      const result = await sdk.smsThreads.sendMessage({ smsId: props.smsId });

      if (result.status === SMSStatus.Failed || result.status === SMSStatus.Undelivered) {
        toast.error(result.errorMessage || 'SMS failed to send.');
      } else {
        toast.success('SMS sent successfully');
        emit('sent');
      }
    } catch (err: any) {
      toast.error(err.rawValue?.detail || err.message || 'Failed to send SMS');
    } finally {
      isSending.value = false;
    }
  };
</script>

<template>
  <Button :loading="isSending" @click="sendDraft">
    <i class="far fa-paper-plane mr-2" />
    Send
  </Button>
</template>
